import fileUploadTemplate from './file_upload.html';

function FileUploadCtrl($scope, Upload) {
    'ngInject';

    /***
     * @ngdoc method
     * @name uploadFile
     * @methodOf BB:bbItemDetails
     * @description
     * Upload a file
     * For more information see https://github.com/danialfarid/ng-file-upload
     * To use this module:
     *
     * @param {object} item basket item
     * @param {object} file uploaded file
     * @param {number} existing attachment id
     * @param {array} errFiles errors array
     */
    $scope.uploadFile = function (item, file, err_files, existing) {
        $scope.err_file = err_files && err_files[0];
        $scope.show_error = false;
        $scope.file_type_error = false;
        $scope.my_file = file;
        const accepted_files = $scope.accept.replace(/\'/g, '').split(',');
        const file_is_valid = file && ((0 <= accepted_files.indexOf(file.type)) || (0 <= file.type.indexOf('image')));


        if (file_is_valid) {
            let att_id;
            if (existing) {
                att_id = existing;
            } else {
                att_id = null;
            }

            let method = 'POST';
            if (att_id) {
                method = 'PUT';
            }
            const url = item.$href('add_attachment');

            const onSuccess = function (response) {
                file.result = response.data;
                item.attachment = response.data;
                item.attachment_id = response.data.id;
                return file.progress = 100;
            };

            const onError = function (response) {
                $scope.show_error = true;
                return file.progress = 100;
            };

            const onProgress = evt => file.progress = Math.min(100, parseInt((99.0 * evt.loaded) / evt.total));

            Upload.rename(file, file.name.replace(/[^\x00-\x7F]/g, '')); //eslint-disable-line no-control-regex

            file.upload = Upload.upload({
                url,
                method,
                data: {attachment_id: att_id},
                file
            });

            return file.upload.then(onSuccess, onError, onProgress);

        } else if (file_is_valid === false) {
            return $scope.file_type_error = true;
        }
    };

}

function fileUploadDirective() {
    'ngInject';

    return {
        restrict: 'A',
        replace: false,
        scope: {
            accept: '@',
            prettyAccept: '@',
            maxSize: '@',
            item: '='
        },
        controller: FileUploadCtrl,
        templateUrl: fileUploadTemplate.id
    };
}

/***
 * @ngdoc directive
 * @name BB:bbFileUpload
 * @restrict AE
 * @scope true
 *
 * @description
 * File upload
 *
 *
 <example>
 <file name="index.html">
 <div
 bb-file-upload
 item="item"
 max-size="100KB"
 pretty-accept="images, .pdf, .doc/docx"
 accept="'application/pdf,application/msword,image/*'">
 </div>
 </file>
 </example>
 */

angular
    .module('BB')
    .directive('bbFileUpload', fileUploadDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/file-upload/file_upload.directive.js